import { ContentGroupType } from '../types/others';

export const getContentGroupUploadFileName = (contentGroupType?: ContentGroupType) => {
  let prefix;
  switch (contentGroupType) {
    case 'collection':
      prefix = 'cgc'; // content group collection
      break;
    case 'bundle':
      prefix = 'cgb'; // content group bundle
      break;
    default:
      prefix = 'cgo'; // content group other
  }

  const randomString = Math.random().toString(36).substring(2, 10);
  return prefix?.concat('-', randomString);
};
